import { makeStyles } from '@material-ui/core';
import {
  Page,
  Content,
  ContentHeader,
  SupportButton,
} from '@backstage/core-components';
import { GithubPipelinesTable } from '../GithubPipelinesTable';

const useStyles = makeStyles({
  content: {
    maxWidth: '120rem',
    justifySelf: 'center',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
  },
});

export const GithubActionsContent = () => {
  const classes = useStyles();
  return (
    <Page themeId="tool">
      <Content className={classes.content}>
        <ContentHeader title="Pipeline runs">
          <SupportButton>
            In case of a need for support, please reach out to Team Platform
            Surface
          </SupportButton>
        </ContentHeader>
        <GithubPipelinesTable />
      </Content>
    </Page>
  );
};
